export type DocumentCss = string | { shadowedCss: string; exposedCss: string } | null | undefined;

export const shadowedCss = (css: DocumentCss): string => (typeof css === 'string' ? css : css?.shadowedCss ?? '');

export const exposedCss = (css: DocumentCss, fallback?: string): string => (css && typeof css !== 'string' ? css.exposedCss : fallback ?? '');
